export default {
  'clocks': [
    'clock0830_1200',
    'clock1300_1800'
  ]
}
